module.exports = __webpack_public_path__ + "img/cloud.07bd5154.png";